'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isLineAffectedByDrag = exports.hasConnectingElementIds = exports.isDraggingLineControlPoint = exports.isDraggingLineEdge = undefined;

var _lineConstants = require('../../../common/lines/lineConstants');

var isDraggingLineEdge = exports.isDraggingLineEdge = function isDraggingLineEdge(itemType) {
    return itemType === _lineConstants.LINE_EDGE_DND_TYPE;
}; // Constants
var isDraggingLineControlPoint = exports.isDraggingLineControlPoint = function isDraggingLineControlPoint(itemType) {
    return itemType === _lineConstants.LINE_CONTROL_POINT_DND_TYPE;
};
var hasConnectingElementIds = exports.hasConnectingElementIds = function hasConnectingElementIds(item) {
    return item && item.connectingElementIds && item.connectingElementIds.length;
};

var isLineAffectedByDrag = exports.isLineAffectedByDrag = function isLineAffectedByDrag(item, itemType) {
    return isDraggingLineEdge(itemType) || hasConnectingElementIds(item) || isDraggingLineControlPoint(itemType);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/dnd/dragLayerUtil.js
// module id = 674
// module chunks = 0